import React from 'react';
import { map } from 'lodash';
import { pure } from 'recompose';
import { tracker } from 'angieslist-app-platform';
import classNames from 'classnames';
import urlCatalog from '@angi/url-catalog';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import { Row, Col } from 'angieslist-react-components';
import { Showcase } from '../../common/profileService';
import ShowcaseIndexCard from './ShowcaseIndexCard';
import ArrayMove from '../../../../app/common/utils/ArrayMove';
import './ShowcaseGrid.scss';
import DragIcon from '../assets/drag.svg';
import CameraIcon from '../assets/Camera';
import { PENDING_UPGRADE_STATE } from '../../../home/common/selectors/upgradeStateSelectors';

type Props = {
  publishedShowcases: Showcase[],
  serviceProviderId: string | number,
  userId: string,
  archiveShowcase: (showcaseId: number, serviceProviderId: string | number) => void,
  showcasePendingRemoval?: boolean,
  saveShowcaseOrder: any,
  shouldHideEdit: boolean,
  serviceProviderUpgradeState: string,
};

const SortableItem = SortableElement(({
  value, serviceProviderId, archiveShowcase, showcasePendingRemoval, shouldHideEdit,
}) => (
  <ShowcaseIndexCard
    key={`sortable-showcase-index-card-${value.showcaseId}`}
    showcase={value}
    serviceProviderId={serviceProviderId}
    archiveShowcase={archiveShowcase}
    isLoading={showcasePendingRemoval === value.showcaseId}
    isDraggable
    shouldHideEdit={shouldHideEdit}
  />
));

const SortableList = SortableContainer(({
  items, serviceProviderId, archiveShowcase, showcasePendingRemoval, shouldHideEdit,
}) => (
  <div className="clearfix">
    <ul style={{ margin: 0, padding: 0 }}>
      {
        items.map((value, index) => (
          <SortableItem
            key={`item-${value.showcaseId}`}
            index={index}
            value={value}
            serviceProviderId={serviceProviderId}
            archiveShowcase={archiveShowcase}
            showcasePendingRemoval={showcasePendingRemoval}
            shouldHideEdit={shouldHideEdit}
          />
        ))
      }
    </ul>
  </div>
));

class ShowcaseAdvertiserPublishedTab extends React.Component {
  onSortEnd = ({ oldIndex, newIndex }) => {
    const newShowcaseOrder = map(ArrayMove(this.props.publishedShowcases, oldIndex, newIndex), 'showcaseId');
    this.props.saveShowcaseOrder(newShowcaseOrder, this.props.serviceProviderId)
      .then(tracker.track('Item Moved', {
        activityLocation: 'SP : My Business : Showcase',
        description: 'Showcase Reordered',
        serviceProviderId: this.props.serviceProviderId,
        userId: this.props.userId,
      }));
  };

  getContainerElement = () => this.containerEl;

  props: Props;

  render() {
    const {
      publishedShowcases,
      serviceProviderId,
      archiveShowcase,
      showcasePendingRemoval,
      shouldHideEdit,
      serviceProviderUpgradeState,
    } = this.props;
    const pending = serviceProviderUpgradeState === PENDING_UPGRADE_STATE;

    return (
      <Row>
        <div
          id="add-a-project"
          className={!pending && 'show-pointer'}
        >
          <a
            id="add-a-project-link"
            className={pending && 'hide-pointer'}
            href={!pending && `/app/showcase/${serviceProviderId}`}
          >
            <span className="make-div-link" />
          </a>
          <div id="camera-icon">
            <CameraIcon
              className={classNames('icon', pending && 'icon-disabled')}
            />
          </div>
          <p
            id="add-a-project-text"
            className={pending ? 'disabled' : 'enabled'}
          >
            Add a project
          </p>
        </div>
        <div ref={
          element => this.containerEl = element // eslint-disable-line no-return-assign
        }
        >
          <SortableList
            axis="xy"
            items={publishedShowcases}
            onSortEnd={this.onSortEnd}
            serviceProviderId={serviceProviderId}
            archiveShowcase={archiveShowcase}
            showcasePendingRemoval={showcasePendingRemoval}
            helperContainer={this.getContainerElement}
            shouldHideEdit={shouldHideEdit}
          />
        </div>
        <div className="showcase-tab-status-text" >
          <Row id="showcase-drag-insight" style={{ display: 'flex' }}>
            <Col xs={2} md={1}>
              <div id="drag-icon">
                <img src={DragIcon} alt="Drag Icon" />
              </div>
            </Col>
            <Col xs={10} md={11}>
              <p id="drag-info-text">Drag to choose the order in which your projects will be displayed.</p>
            </Col>
          </Row>
        </div>
        <p style={{ margin: '30px 16px 40px' }}>
          Want to upload a single photo or a team headshot? Head to
          <a
            id="Edit-Profile--MenuNav-Photo-Gallery"
            href={urlCatalog.office.spProfile.images(serviceProviderId)}
            style={{ color: '#02819E', fontWeight: 'bold' }}
          >
            &nbsp;photos.
          </a>
        </p>
      </Row>
    );
  }
}

export default pure(ShowcaseAdvertiserPublishedTab);



// WEBPACK FOOTER //
// ./src/modules/profile/browser/components/ShowcaseAdvertiserPublishedTab.js